import { render, staticRenderFns } from "./Register-transferencia.vue?vue&type=template&id=740c64ec&"
import script from "./Register-transferencia.vue?vue&type=script&lang=js&"
export * from "./Register-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./Register-transferencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports